import { FC } from 'react';
import Image from 'next/legacy/image';
import { TFunction } from 'next-i18next';
import type { TopDestinationSlug } from 'src/common/components/LandingPageTopDestinations/types';
import { NEXT_STATIC_IMAGES, PATHS } from 'src/common/constants';
import UniversalLink from 'src/common/components/UniversalLink';
import Typography from 'src/common/components/Typography';
import Icon from 'src/common/components/IconDS22';
import styles from './LocationCard.module.scss';

export type LocationCardProps = {
  slug: TopDestinationSlug;
  translationFunction?: TFunction;
};

const LocationCard: FC<LocationCardProps> = ({
  slug,
  translationFunction,
}) => {
  const imageSrc = slug.imageSlug
    // For cases when an alternative image is required and we already have an
    // image for same location
    ? `${NEXT_STATIC_IMAGES}top-destinations/${slug.imageSlug}.jpg`
    : `${NEXT_STATIC_IMAGES}top-destinations/${slug.slug}.jpg`;
  const url = `${PATHS.SEARCH}${slug.slug}/`;

  return (
    <UniversalLink
      href={url}
      className={styles.root}
    >
      <div className={styles.image}>
        <Image
          src={imageSrc}
          alt={url}
          layout="fill"
          objectFit="cover"
        />
      </div>
      <div className={styles.content}>
        <div className={styles.text}>
          <Typography
            size="body-xl"
            weight="semibold"
            type="p"
            className={styles.white}
          >
            {translationFunction ? translationFunction(slug.title) : slug.title}
          </Typography>
          {(
            <Typography
              size="body-l"
              type="p"
              className={styles.subtitle}
            >
              {slug.subtitle && (
                translationFunction ? translationFunction(slug.subtitle) : slug.subtitle
              )}
            </Typography>
          )}
        </div>
        <div className={styles.arrow}>
          <Icon
            id="arrow-right"
            size="m"
          />
        </div>
      </div>
    </UniversalLink>
  );
};

export default LocationCard;
